/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ShiftReportOpenTaskItemType {
  Downtime = 'Downtime',
  QaCheck = 'QaCheck',
  EmployeeRegistration = 'EmployeeRegistration'
}
